module.exports = __webpack_public_path__ + "img/2.06cbf2b1.jpg";